export const TEST_ID = 'cardLink';
